import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { SmallContainer } from 'src/components/container';
import { fontSecondary } from 'src/styles/fonts';
import { spacing3, spacing5, spacing7, spacing9 } from 'src/styles/spacing';

export const StyledChooseContainer = styled(SmallContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: ${spacing7};
  margin-bottom: ${spacing9};
`;

export const StyledSubtitle = styled(Typography)`
  font-weight: bold;
  margin-top: ${spacing5};
  font-family: ${fontSecondary};
`;

export const StyledText = styled(Typography)`
  padding: ${spacing3} 0;
`;
